import { graphql } from '@/client/services/api/graphql/gql';

export const createUserContentViewMutation = graphql(`
  mutation CreateUserContentView($userContentView: UserContentViewCreateInput!) {
    createUserContentView(userContentView: $userContentView) {
      id
    }
  }
`);
